document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', function () {
  const menuButton = document.querySelector('.mobile-menu-button');
  const menuDrawer = document.querySelector('.mobile-drawer');
  const closeButton = document.querySelector('.mobile-menu-close');
  const overlay = document.querySelector('.drawer-overlay');

  if (menuButton && menuDrawer && closeButton && overlay) {
    const openMenu = () => {
      menuDrawer.classList.add('is-open');
      overlay.classList.add('is-open');
      menuDrawer.setAttribute('aria-hidden', 'false');
      menuButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
    };
    const closeMenu = () => {
      menuDrawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      menuDrawer.setAttribute('aria-hidden', 'true');
      menuButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('drawer-open');
    };
    menuButton.addEventListener('click', openMenu);
    closeButton.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });
    menuDrawer.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
  }
});
